// extracted by mini-css-extract-plugin
export default {"digicert":"styles_digicert__31K6B","digicert__spacing":"styles_digicert__spacing__H8lJY","digicert__icon":"styles_digicert__icon__szYjJ"};